module.exports = __webpack_public_path__ + "static/media/add-purple.488ab7f8.svg";